import axios from 'axios';
import models from './models';

const getServerParams = async () => {
    console.log('GET SERVER PARAMS API');
    try {
        let params = await axios.get('/job/params')
            .then( response => {
                return response.data;
            });
        return params;
    } catch (error) {
        throw error;
    }
};

const reset = async () => {
    console.log('RESET API');
    try {
        await axios.post('/job/reset');
    } catch (error) {
        throw error;
    }
} 

const add = async (file) => {
    console.log('ADD API');
    try {
        const formData = new FormData();
        formData.append('multipartFile', file);
        return await axios.post('/job/add', formData);
    } catch (error) {
        throw error;
    }
}

const addAll = async (files) => {
    console.log('ADDALL');
    try {
        let list = [];
        files.forEach( file => {
            list.push(
                add(file)
            );
        });
        return list;
    } catch (error) {
        throw error;
    }
}

const submit = async (selectedModel, cellSize) => {
    console.log('SUBMIT API');
    try {
        const formData = new FormData();
        formData.append('modelId', models[selectedModel].id);
        formData.append('additionalParameters', JSON.stringify({target_object_size: cellSize}));

        return await axios.post('/job/submit', formData);
    } catch (error) {
        throw error;
    }
}

const getResultImage = async (imageId) => {
    try {
        let image = await axios.get('/job/result/' + imageId, {responseType: "blob"})
		return image;
    } catch (error) {
		throw error;
    }
}

const getResult = async () => {
    console.log('GET RESULT API');

    try {
        let result = await axios.post('/job/result')
        return result;
    } catch (error) {
        throw error;
    }
}

const downloadResultZip = async () => {
    console.log("DOWNLOAD ZIP RESULTS API"); 
    try {
        axios.get('/job/result-zip', {responseType: "blob"})
            .then( response => {   
                var dlink = document.createElement('a');
                dlink.download = "segmentation.zip"; //TODO: can we get the name returned from the server?
                dlink.href = window.URL.createObjectURL(response.data);
                document.body.appendChild(dlink);
                dlink.click();
                dlink.remove();
            })
    } catch (error) {
        throw error;
    }
}

export {
    reset, 
    submit, 
    getServerParams, 
    getResult, 
    getResultImage, 
    downloadResultZip, 
    add, 
    addAll
};
